import { render } from "./ProductMainList.vue?vue&type=template&id=568cb38f"
import script from "./ProductMainList.vue?vue&type=script&lang=js"
export * from "./ProductMainList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__